//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  name:'ISS',
  data() {
    return {
      defaultJson:{
        "Serious": "较重",
        "External": "外部",
        "Moderate": "中度",
        "Face": "脸",
        "Severe": "重度",
        "Critical": "极重",
        "Head & Neck": "头和颈",
        "Extremities": "肢端",
        "Thorax": "胸",
        "Minor": "轻度",
        "Unsurvivable": "致命",
        "Abdomen": "腹"
      },
      form:{
        head:'',
        face:'',
        thorax:'',
        abdomen:'',
        extremities:'',
        external:''
      },
      hasScore:false,
      disabled:false,
      dataList:[
        {value:"1",name:'轻度'},
        {value:"2",name:'中度'},
        {value:"3",name:'较重'},
        {value:"4",name:'重度'},
        {value:"5",name:'极重'},
        {value:"6",name:'致命'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    sortNum(){

    },
    maxNSum(num, obj ){
      let self = this
      obj.sort((a,b)=> {return (b-a)})
      let sum = 0
      console.log(obj);
      for (let i = 0; i < num; i++) {
         console.log(obj[i]);
        sum += obj[i]
        
      }
      console.log(sum);
      return sum
    },

  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          form[key] = Number(form[key])
        }
      }
      /** 计算规则： 
       * 1、有一个选择致命  得分75分
       * 2、不满足条件1，则取最大三个数的平方
       */
      let unsurvivable = form.head == 6 ? 1 : (form.face == 6 ? 1 : (form.thorax == 6 ? 1 : (form.abdomen == 6 ? 1 : (form.extremities == 6 ? 1 : (form.external == 6 ? 1 : 0)))))
      let result = unsurvivable ? 75 : (self.maxNSum(3,[(form.head*form.head),(form.face*form.face),(form.thorax*form.thorax),(form.abdomen*form.abdomen),(form.extremities*form.extremities),(form.external*form.external)]))
      self.hasScore = true
      return result? String(result) : ''
    }
  },
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/ISS.vue